import { render, staticRenderFns } from "./NewPermissionList.vue?vue&type=template&id=fd05e872&scoped=true"
import script from "./NewPermissionList.vue?vue&type=script&lang=js"
export * from "./NewPermissionList.vue?vue&type=script&lang=js"
import style0 from "./NewPermissionList.vue?vue&type=style&index=0&id=fd05e872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd05e872",
  null
  
)

export default component.exports